import api from "./api";

export interface HomeSection<T = any> {
  content: T;
  created_at: string;
  id: number;
  section: string;
  updated_at: string;
}

// Convenience function for EarnWithHareeng section
export async function fetchEarnWithHareengSection() {
  return fetchHomeSection<{
    bullets: string[];
    buttons: { label: string; link: string }[];
    image: string;
    subtitle: string;
    title: string;
  }>("earnwithhareeng");
}

// Fetch any home section by name (e.g. 'earnwithhareeng')
export async function fetchHomeSection<T = any>(
  section: string,
): Promise<HomeSection<T> | null> {
  const res = await api.get(`/home/${section}`);
  if (!res.data || !res.data.id) return null;
  return res.data as HomeSection<T>;
}
